import * as FullStory from '@fullstory/browser';
import { Userpilot } from 'userpilot';

import fullstory from '~/api/fullstory';
import {
  PORTAL_FULLSTORY_ORG_ID,
  FULLSTORY_RELAY,
  URL
} from '~/common/helpers/environment';

type UserData = {
  email: string;
  realm: string;
};

class WebAnalytics {
  static async init(userData: UserData | undefined) {
    const isAdBlockEnabled = await fullstory.isAdBlockEnabled();
    const fsHost = URL.substring(URL.indexOf('://') + 3);

    FullStory.init({
      orgId: PORTAL_FULLSTORY_ORG_ID,
      host:
        isAdBlockEnabled && String(FULLSTORY_RELAY) === 'true'
          ? `${fsHost}/fsrelay`
          : undefined,
      script:
        isAdBlockEnabled && String(FULLSTORY_RELAY) === 'true'
          ? `${fsHost}/fsscript/s/fs.js`
          : undefined
    });

    if (!userData) return FullStory.anonymize();

    return FullStory.identify(userData.email, {
      email: userData.email,
      realm_str: userData.realm
    });
  }

  static sendEvent(eventName: string, data: Record<string, unknown> = {}) {
    Userpilot.track(eventName, data);

    if (!FullStory.isInitialized()) return;

    try {
      FullStory.event(eventName, data);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }

  static startSurvey(eventName: string) {
    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      if (window.Intercom) window.Intercom('trackEvent', eventName);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  }
}

export default WebAnalytics;
